import CandidatePlacedIcon from "@assets/svg/CandidatePlacedIcon";
import CommissionIcon from "@assets/svg/CommissionIcon";
import EmailSuccess from "@assets/svg/EmailSuccess";
import InvitationAcceptedIcon from "@assets/svg/InvitationAcceptedIcon";
import InviteReceived from "@assets/svg/InviteReceived";
// @ts-ignore
import ProfileImg from "@assets/images/profilepic.png";
// @ts-ignore
import AgencyImg from "@assets/images/agency.jpg";
// @ts-ignore
import GoogleImg from "@assets/images/google.jpg";
import CalenderIcon from "@assets/svg/CalenderIcon";
import AssessmentIcon from "@assets/svg/AssessmentIcon";
import EyeIcon from "@assets/svg/EyeIcon";
import EditIcon from "@assets/svg/EditIcon";
import ProfileIcon from "@assets/svg/ProfileIcon";
import TickThinOutline from "@assets/svg/TickThinOutline";
import JobMatchesIcon from "@assets/svg/JobMatchesIcon";
import { Briefcase, LogOut, UserIcon } from "lucide-react";
import dayjs from "dayjs";
import MembersIcon from "@assets/svg/MembersIcon";

type TrackerType =
  | "referralFee"
  | "offer"
  | "offerAccepted"
  | "invitation"
  | "poll"
  | "shortlist"
  | "view"
  | "jobPosted"
  | "applied"
  | "requirementPosted"
  | "matched"
  | "companyAdd"
  | "edit"
  | "register";

function getIcon(type: TrackerType) {
  switch (type) {
    case "referralFee":
      return <CommissionIcon className={"w-5.5 h-5.5"} fill="gray" />;
    case "offer":
      return <JobMatchesIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "offerAccepted":
      return <JobMatchesIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "invitation":
      return <CalenderIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "poll":
      return <CalenderIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "shortlist":
      return <AssessmentIcon className={"w-5 h-5"} fill={"gray"} />;
    case "view":
      return <EyeIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "jobPosted":
      return (
        <TickThinOutline
          className={"w-5 h-5 border rounded-full border-gray-500"}
          fill={"gray"}
        />
      );
    case "requirementPosted":
      return (
        <TickThinOutline
          className={"w-5 h-5 border rounded-full border-gray-500"}
          fill={"gray"}
        />
      );
    case "matched":
      return (
        <TickThinOutline
          className={"w-5 h-5 border rounded-full border-gray-500"}
          fill={"gray"}
        />
      );
    case "applied":
      return (
        <TickThinOutline
          className={"w-5 h-5 border rounded-full border-gray-500"}
          fill={"gray"}
        />
      );
    case "companyAdd":
      return (
        <TickThinOutline
          className={"w-5 h-5 border rounded-full border-gray-500"}
          fill={"gray"}
        />
      );
    case "edit":
      return <EditIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
    case "register":
      return <ProfileIcon className={"w-5 h-5"} fill={"gray"} />;
    default:
      return <CommissionIcon className={"w-5.5 h-5.5"} fill={"gray"} />;
  }
}
function getTitle(type: TrackerType) {
  switch (type) {
    case "referralFee":
      return "Referral Fee Pending";
    case "offer":
      return "Offer";
    case "offerAccepted":
      return "Offer Accepted";
    case "invitation":
      return "Interview Invitation";
    case "poll":
      return "Availability Poll";
    case "shortlist":
      return "Shortlisted";
    case "view":
      return "Applcation Viewed";
    case "applied":
      return "Applied";
    case "jobPosted":
      return "Job Posted";
    case "requirementPosted":
      return "Requirement Posted";
    case "matched":
      return "Matched";
    case "companyAdd":
      return "Hiring Company Add";
    case "edit":
      return "Profile Edit";
    case "register":
      return "Registration";
    default:
      return "Default";
  }
}

function getDescImage(type: TrackerType) {
  switch (type) {
    case "referralFee":
      return <img src={AgencyImg} className="w-9 h-9 rounded-full" />;
    case "offer":
      return <img src={GoogleImg} className="w-9 h-9 rounded-full" />;
    case "offerAccepted":
      return <img src={ProfileImg} className="w-9 h-9 rounded-full" />;
    case "invitation":
      return <img src={GoogleImg} className="w-9 h-9 rounded-full" />;
    case "poll":
      return <img src={GoogleImg} className="w-9 h-9 rounded-full" />;
    case "shortlist":
      return <img src={ProfileImg} className="w-9 h-9 rounded-full" />;
    case "view":
      return <img src={GoogleImg} className="w-9 h-9 rounded-full" />;
    case "requirementPosted":
      return <img src={GoogleImg} className="w-9 h-9 rounded-full" />;
    case "matched":
      return <MembersIcon className={"w-9 h-9"} fill="#4d4d4d" />;
    case "companyAdd":
      return <img src={ProfileImg} className="w-9 h-9 rounded-full" />;

    default:
      return <img src={ProfileImg} className="w-9 h-9 rounded-full" />;
  }
}

function getDescription(type: TrackerType) {
  switch (type) {
    case "referralFee":
      return (
        <span className="flex flex-wrap items-center gap-1 text-xs font-medium text-charcoal">
          Referral fee payment due to{" "}
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Sarah Jane</span>
          for the placement of
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          at
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          for a requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "offer":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          submitted offer to
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          for a requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "offerAccepted":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Jo Bloggs </span>
          has accepted an offer from
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          for a requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "invitation":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          has requested an interview with
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          for requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer.
          </span>
        </span>
      );
    case "poll":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          has sent you an{" "}
          <span className="font-bold text-gray-600">availability poll. </span>
        </span>
      );
    case "shortlist":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Jo Bloggs </span>
          has been shortlisted for job titled
          <span className="font-bold text-gray-600">
            React Frontend Developer
          </span>
          for a requirement submitted by
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe</span>
        </span>
      );
    case "view":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          has viewed
          <img src={ProfileImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          application for the position
          <span className="font-bold text-gray-600">
            React Frontend Developer.{" "}
          </span>
        </span>
      );
    case "jobPosted":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          posted a new job titled
          <span className="font-bold text-gray-600">
            React Frontend Developer
          </span>
          from a requirement submitted by
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe</span>
        </span>
      );
    case "applied":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Jo Bloggs</span>
          applied for a job titled
          <span className="font-bold text-gray-600">
            React Frontend Developer
          </span>
          from a requirement submitted by
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe</span>
        </span>
      );
    case "requirementPosted":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">Google Inc Europe</span>
          has posted a new requirement titled
          <span className="font-bold text-gray-600">
            React Frontend Developer
          </span>
        </span>
      );
    case "matched":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          47 candidates have been matched for Job post titled
          <span className="font-bold text-gray-600">
            React Frontend Developer{" "}
          </span>
          from a requirement submitted by
          <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe.</span>
        </span>
      );
    case "companyAdd":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You</span>
          added <img src={GoogleImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">Google Inc Europe.</span>
          to your
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          Hiring Company Network
        </span>
      );
    case "edit":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You </span>
          successfully updated
          <img src={AgencyImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">ABC Recruitment</span>
          details.
        </span>
      );
    case "register":
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">You </span>
          successfully registered an admin account on behalf of{" "}
          <img src={AgencyImg} className="w-7 h-7 rounded-full" />
          <span className="font-bold text-gray-600">ABC Recruitment.</span>
        </span>
      );
    default:
      return (
        <span className="text-xs gap-1 flex items-center flex-wrap text-charcoal font-medium">
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          sent you an offer from{" "}
          <span className="font-bold text-gray-600">ABC Recruitment </span>
          regarding
          <span className="font-bold text-gray-600">ABC Recruitment.</span>
        </span>
      );
  }
}

type CardProps = {
  type: TrackerType;
};

const Card = ({ type }: CardProps) => {
  return (
    <div className="flex gap-3">
      <div className="flex items-center justify-center w-6 h-6 rounded-full">
        {getIcon(type)}
      </div>
      <div className="flex flex-col gap-1 w-full pt-1">
        <span className="font-semibold text-xs gap-5 flex text-charcoal">
          {getTitle(type)}
          <span className="font-medium text-light-black">
            {dayjs().format("HH:mm DD/MM/YYYY")}
          </span>
        </span>
        <div className="flex items-center text-xs text-charcoal bg-[#fafafa] w-full rounded-md p-3 gap-3">
          {getDescImage(type)}
          {getDescription(type)}
        </div>
      </div>
    </div>
  );
};

const RecruiterTrackerPageStatic = () => {
  return (
    <div className="flex flex-col flex-1 min-h-0 rounded-md bg-white p-5">
      <span className="font-bold text-charcoal mx-auto">Activity Tracker</span>

      {/* Tracker List */}
      <div className="flex flex-col min-h-0 my-10 w-[70%] mx-auto gap-6 overflow-y-scroll no-scrollbar">
        <Card type="referralFee" />
        <Card type="offerAccepted" />
        <Card type="offerAccepted" />
        <Card type="offer" />
        <Card type="invitation" />
        <Card type="poll" />
        <Card type="shortlist" />
        <Card type="view" />
        <Card type="jobPosted" />
        <Card type="matched" />
        <Card type="applied" />
        <Card type="jobPosted" />
        <Card type="requirementPosted" />
        <Card type="companyAdd" />
        <Card type="edit" />
        <Card type="register" />
      </div>
    </div>
  );
};

export default RecruiterTrackerPageStatic;
